import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP_NUMBER = '+917579997999';
const WHATSAPP_MESSAGE = 'Hi, I need assistance with my HR query.';

const WhatsAppButton = ({ user }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  // Only show for employees
  if (!user || user.role !== 'employee') {
    return null;
  }

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(WHATSAPP_MESSAGE);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const dismissTooltip = (e) => {
    e.stopPropagation();
    setShowTooltip(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-float-btn">
      {/* Tooltip */}
      {showTooltip && (
        <div 
          className="absolute bottom-16 right-0 bg-white rounded-lg shadow-lg p-3 pr-8 min-w-[200px] animate-bounce-slow"
          style={{ animation: 'bounce-slow 2s ease-in-out infinite' }}
        >
          <button 
            onClick={dismissTooltip}
            className="absolute top-2 right-2 text-slate-400 hover:text-slate-600"
          >
            <X size={14} />
          </button>
          <p className="text-sm font-medium text-slate-800">Need Help?</p>
          <p className="text-xs text-slate-500 mt-1">Chat with HR Support</p>
          <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
        </div>
      )}
      
      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          flex items-center gap-2 
          bg-[#25D366] hover:bg-[#128C7E] 
          text-white font-medium
          rounded-full shadow-lg hover:shadow-xl
          transition-all duration-300 ease-in-out
          ${isHovered ? 'pl-4 pr-5 py-3' : 'p-4'}
        `}
        style={{
          boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          className={`${isHovered ? 'w-6 h-6' : 'w-7 h-7'} fill-current transition-all duration-300`}
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        {isHovered && (
          <span className="whitespace-nowrap text-sm">Chat with HR</span>
        )}
      </button>

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;
